import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  max-width: 30em;
`
const Label = styled.label`
  font-size: 13px;
  line-height: 18px;
  color: #ff6868;
  font-family: OpenSansRegular
`
const Input = styled.input`
  outline: none;
  font-size: 17px;
  line-height: 23px;
  letter-spacing: -0.01em;
  margin-top: 0px;
  padding: 8px 0;
  border: 0px;
  border-bottom: 1px solid #dcdcdc;
  background: none;
  transition: border-bottom 150ms ease-in-out;
  &:focus{
    border-bottom: 1.5px solid #9240C9;
    &:hover{
      border-bottom: 2px solid #9240C9;
    }
  }
  &:hover{
    border-bottom: 2px solid rgba(0, 0, 0, 0.87);
  font-family: OpenSansRegular
  };
  ::placeholder {
    color: f9f9f9
  }
`

const InputField = ({ type, label, name, value, handleChange, placeholder }) => {
  return (
    <InputContainer>
      <Label>{label}</Label>
      <Input name={name} onChange={handleChange} value={value} type={type} placeholder={placeholder} />
    </InputContainer>
  )
}

InputField.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string
}

export default InputField
